import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromProjects from './projects.reducer';
import * as fromContacts from './contacts.reducer';
import * as fromVersions from './versions.reducer';
import * as fromResult from './result.reducer';
import * as fromCredits from './credits.reducer';
import * as fromCompare from './compare.reducer';
import * as fromTree from './tree.reducer';
import * as fromMapping from './mapping.reducer';
import * as fromMaterial from './materials.reducer';
import * as fromUI from './ui.reducer';
import * as fromViewer from './viewer.reducer';

export interface DashboardState {
  projects: fromProjects.ProjectsState;
  contacts: fromContacts.ContactsState;
  versions: fromVersions.VersionState;
  result: fromResult.ResultState;
  credits: fromCredits.CreditsState;
  compare: fromCompare.CompareState;
  tree: fromTree.TreeState;
  mapper: fromMapping.MappingState;
  materials: fromMaterial.MaterialsState;
  viewer: fromViewer.ViewerState;
  ui: fromUI.ViewerState;
}

// export interface MapperState extends DashboardState {
//   mapping: fromMapping.MappingState;
// }

export const reducers: ActionReducerMap<DashboardState> = {
  //@ts-ignore
  projects: fromProjects.reducer,
  //@ts-ignore
  contacts: fromContacts.reducer,
  //@ts-ignore
  versions: fromVersions.reducer,
  //@ts-ignore
  result: fromResult.reducer,
  //@ts-ignore
  credits: fromCredits.reducer,
  //@ts-ignore
  compare: fromCompare.reducer,
  //@ts-ignore
  tree: fromTree.reducer,
  //@ts-ignore
  mapper: fromMapping.reducer,
  //@ts-ignore
  materials: fromMaterial.reducer,
  //@ts-ignore
  ui: fromUI.reducer,
  //@ts-ignore
  viewer: fromViewer.reducer,
};

// export const mapperReducer: ActionReducerMap<MapperState> = {
//   //@ts-ignore
//   projects: fromProjects.reducer,
//   //@ts-ignore
//   contacts: fromContacts.reducer,
//   //@ts-ignore
//   versions: fromVersions.reducer,
//   //@ts-ignore
//   credits: fromCredits.reducer,
//   //@ts-ignore
//   compare: fromCompare.reducer,
//   //@ts-ignore
//   mapping: fromMapping.reducer,
//   //@ts-ignore
//   ui: fromUI.reducer,
//   //@ts-ignore
//   viewer: fromViewer.reducer,
// };

export const getProductsState = createFeatureSelector<DashboardState>('appState');
